import { usePresenceHeartbeat } from '../hooks/usePresenceHeartbeat';

/**
 * Component that manages presence heartbeat within AuthContext
 */
export function PresenceManager() {
  usePresenceHeartbeat();
  return null;
}
